import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

export interface UserPreference {
  inputResep?: {
    showAutocompleteFreeText: boolean;
  };
  callAntrianKlinik?: string;
  feature?: {
    downloadCPPT?: boolean;
    enableDashboard?: boolean;
  };
  daftarPasienIgd?: {
    statusFilter?: string;
  };
}

async function update(userId, data: UserPreference) {
  const response = await http
    .putData(`/user/${userId}/preference`, { content: data })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function find(userId): Promise<UserPreference> {
  const response = await http
    .getData(`/user/${userId}/preference`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  update,
  find
};
